var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandArrowsAltSolid = function SvgExpandArrowsAltSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    className: "svgr-icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4v9h2V7.438L14.563 16 6 24.563V19H4v9h9v-2H7.438L16 17.438 24.563 26H19v2h9v-9h-2v5.563L17.438 16 26 7.438V13h2V4h-9v2h5.563L16 14.563 7.438 6H13V4Z"
  })));
};
export default SvgExpandArrowsAltSolid;